<template>
  <div class="autocomplete">
    <input
      type="search"
      id="input1"
      class="form-control list-group-item list-group-item-action sidepane "
      placeholder="Search Instrument"  aria-describedby="basic-addon1"
      @input="onChange"
      v-model="search"
      @touchstart="onChange"
      @change="onChange"
      @keydown.down="onArrowDown"
      @keydown.up="onArrowUp"
      @keydown.enter="onEnter"
    />
    <ul id="autocomplete-results" v-show="isOpen" class="autocomplete-results">
      <li class="loading" v-if="isLoading">Loading results...</li>
      <li
        v-else
        v-for="(result, i) in results"
        :key="i"
        @click="setResult(result)"
        class="autocomplete-result list-group-item"
        :class="{ 'is-active': i === arrowCounter }"
      >
        {{ result.instrumentName }}
      </li>
    </ul>
  </div>
</template>
<script>
import { searchMarketWatch, addMarketWatch } from '@/service/restService'
export default {
  name: 'SearchAutoComplete',
  props: {
    items: {
      type: Array,
      required: false,
      default: () => []
    },
    isAsync: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      isOpen: false,
      results: [],
      search: '',
      isLoading: false,
      arrowCounter: -1,
      timer: null
    }
  },
  watch: {
    items: function (value, oldValue) {
      if (value.length !== oldValue.length) {
        this.results = value
        this.isLoading = false
      }
    }
  },
  mounted () {
    document.addEventListener('click', this.handleClickOutside)
  },
  destroyed () {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    searchMarketWatch: function (script) {
      searchMarketWatch(script).then((response) => {
        this.results = response.data
        if (this.results.length > 0) { this.$store.commit('showMw', true) }
        this.isOpen = true
        this.isLoading = false
      }).catch((error) => {
        this.isOpen = false
        this.$store.commit('showMw', false)
        this.isLoading = false
        alert(error.response.data.message[0])
      })
    },
    addMarketWatch: function (scriptId) {
      addMarketWatch(scriptId).then((response) => {
        this.$store.commit('addToMyScripts', response.data.instrumentToken)
        this.$store.commit('addToMarketWatch', response.data)
      }).catch((error) => {
        this.$store.commit('addToast', {
          title: 'Failure!',
          type: 'error',
          message: error.response.data.message[0]
        })
      })
    },
    setResult (result) {
      this.search = null
      this.isOpen = false
      this.$store.commit('showMw', false)
      this.addMarketWatch(result.instrumentToken)
    },
    filterResults () {
      this.results = this.items.filter((item) => {
        return item.toLowerCase().indexOf(this.search.toLowerCase()) > -1
      })
    },
    onChange: function (event) {
      clearTimeout(this.timer)
      this.$emit('input', this.search)
      this.timer = setTimeout(() => {
        if (this.isAsync && this.search.length > 2) {
          this.isLoading = true
          this.searchMarketWatch(this.search)
        } else {
          this.filterResults()
          this.isOpen = true
          this.$store.commit('showMw', false)
        }
      }, 300)
    },
    handleClickOutside (event) {
      if (!this.$el.contains(event.target)) {
        this.isOpen = false
        this.$store.commit('showMw', false)
        this.arrowCounter = -1
      }
    },
    onArrowDown () {
      if (this.arrowCounter < this.results.length) {
        this.arrowCounter = this.arrowCounter + 1
      }
    },
    onArrowUp () {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1
      }
    },
    onEnter () {
      this.search = this.results[this.arrowCounter]
      this.isOpen = false
      this.$store.commit('showMw', false)
      this.arrowCounter = -1
    }
  }
}
</script>
<style>
.autocomplete {
  position: relative;
}

.autocomplete-results {
  padding: 0;
  margin: 0;
  border: 1px solid var(--bs-border-color);
  overflow: auto;
  z-index: 10;
  background-color: var(--bs-body-bg);
}

.autocomplete-result {
  list-style: none;
  text-align: left;
  padding: 4px 20px;
  background-color: var(--bs-tertiary-bg) !important;
  color: var(--bs-body-color);
  cursor: pointer;
}

.autocomplete-result.is-active,
.autocomplete-result:hover {
  background-color: var(--bs-primary) !important;
  color: white;
}
.sidepane {border-color: var(--bs-border-color);}
</style>



// WEBPACK FOOTER //
// src/components/marketwatch/SearchAutoComplete.vue